<lex-field-editor [config]="{disableMenu: true, title: 'Case'}" [fields$]="fields$" (itemDeleted)="onItemDeleted($event)"
                  (addItem)="onAddItem()" (itemChanged)="onItemChanged($event)"></lex-field-editor>
